import { Accordion } from "../../accordion.js";

export default () => {
  const accordionInstances = [];

  document.querySelectorAll(".js-accordion").forEach((accordionEl, i) => {
    const instance = Accordion(accordionEl, i);
    if (instance) {
      accordionInstances.push(instance);
    }
  });

  // If URL has a hash, open the matching accordion item
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1).toLowerCase();
    // Try finding by id first, then fall back to matching title text
    let targetEl = document.getElementById(targetId);
    let match = targetEl && accordionInstances.find((inst) => inst.el === targetEl);

    if (!match) {
      // Fallback: match accordion title text to hash
      match = accordionInstances.find((inst) => {
        const titleEl = inst.el.querySelector(".accordion-item__title");
        if (!titleEl) return false;
        const slug = titleEl.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "")
          .replace(/\s+/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-|-$/g, "");
        return slug === targetId;
      });
    }

    if (match) {
      match.toggleContent(true);
      // Scroll to the accordion after it opens
      setTimeout(() => {
        match.el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }
};